import React from 'react';
import { Link } from 'react-router-dom';

export function WidgetLink ({ to, text, color = '#F95623' }) {
    return (<Link to={to} style={{ color }}>{text}</Link>);
}

// Set display names for debugging.
if (process.env.NODE_ENV !== 'production') {
    WidgetLink.displayName = 'WidgetLink';
}
